// The Test section's text limits, in characters. The server rejects longer text (server/growth.ts) and the browser's
// boxes stop at the same length, so a person can never type something that is bound to be refused.
export const GROWTH_TEXT_LIMITS = Object.freeze({ title: 200, prose: 4000, short: 100 });
